(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-farewell"] = factory();
	else
		root["vue-farewell"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/vue-farewell/dist";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    bind: function bind(el, binding) {
      if (typeof document === 'undefined' || !el) {
        return;
      }

      var getDefaultElementDisplayStyle = function getDefaultElementDisplayStyle() {
        var displayStyles = ['inline', 'block', 'flex', 'inline-block', 'inline-flex', 'inline-table', 'list-item', 'run-in', 'table', 'inherit', 'initial', 'table-row', 'table-column', 'table-cell', 'table-row-group', 'table-column-group', 'table-header-group', 'table-footer-group', 'table-caption'];
        return displayStyles.indexOf(options.elementDisplayStyleOnFire) === -1 ? 'block' : options.elementDisplayStyleOnFire;
      };

      if (options.elementHiddenByDefault === true) {
        el.style.display = 'none';
      }

      var asNumber = function asNumber(value, defaultValue) {
        if (typeof value === 'undefined') return defaultValue;
        return isNaN(Number(value)) ? defaultValue : value;
      };

      var setDefaultCookieExpire = function setDefaultCookieExpire(days) {
        var ms = asNumber(days, 7) * 24 * 60 * 60 * 1000;
        var date = new Date();
        date.setTime(date.getTime() + ms);
        return '; expires=' + date.toUTCString();
      };

      var FIRED_ONCE_KEY = 'fired_once';
      var html = document.documentElement;
      var isAggressive = options.aggressive === true;
      var delay = asNumber(options.delay, 0);
      var sensitivity = asNumber(options.sensitivity, 20);
      var cookieExpire = setDefaultCookieExpire(options.cookieExpire) || '';
      var cookieDomain = options.cookieDomain ? ';domain=' + options.cookieDomain : '';
      var cookieName = options.cookieName ? options.cookieName : FIRED_ONCE_KEY;
      var sitewide = options.sitewide === true ? ';path=/' : '';
      var timer = null;
      var start_delay = asNumber(options.start_delay, 0);
      var disableKeydown = false;

      // Cookie helpers
      var parseCookies = function parseCookies() {
        var cookies = document.cookie.split('; ');
        var res = {};
        for (var i = cookies.length - 1; i >= 0; i--) {
          var el = cookies[i].split('=');
          res[el[0]] = el[1];
        }
        return res;
      };

      var checkCookieValue = function checkCookieValue(name, value) {
        return parseCookies()[name] === value;
      };

      // Methods
      var isDisabled = function isDisabled() {
        return checkCookieValue(cookieName, 'true') && !isAggressive;
      };

      var handleMouseLeave = function handleMouseLeave(e) {
        if (e.clientY > sensitivity) {
          return;
        }
        timer = setTimeout(fire, delay);
      };

      var handleMouseEnter = function handleMouseEnter() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      };

      var handleKeyDown = function handleKeyDown(e) {
        if (disableKeydown) {
          return;
        } else if (!e.metaKey || e.keyCode !== 76) {
          return;
        }
        disableKeydown = true;
        timer = setTimeout(fire, delay);
      };

      var disable = function disable() {
        document.cookie = cookieName + '=true' + cookieExpire + cookieDomain + sitewide;
        html.removeEventListener('mouseleave', handleMouseLeave);
        html.removeEventListener('mouseenter', handleMouseEnter);
        html.removeEventListener('keydown', handleKeyDown);
      };

      var fire = function fire() {
        if (isDisabled()) {
          return;
        }
        if (el) {
          el.style.display = getDefaultElementDisplayStyle();
        }
        if (typeof binding.value === 'function') {
          binding.value();
        }
        disable();
      };

      var attachExitListener = function attachExitListener() {
        if (isDisabled()) {
          return;
        }
        html.addEventListener('mouseleave', handleMouseLeave);
        html.addEventListener('mouseenter', handleMouseEnter);
        html.addEventListener('keydown', handleKeyDown);
      };

      setTimeout(attachExitListener, start_delay);

      el.$destroy = function () {
        disable();
      };
    },
    unbind: function unbind(el) {
      el.$destroy();
    }
  };
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "farewellDirectivePlugin", function() { return farewellDirectivePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__farewell__ = __webpack_require__(0);

var farewellDirectivePlugin = {
  install: function install(Vue, options) {
    Vue.directive('farewell', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__farewell__["a" /* default */])(options));
  }
};
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__farewell__["a" /* default */])());

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// lib/vue-farewell.min.js